export default "__VITE_ASSET__28cdc37f__"